// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__yb7Ap","modal":"Modal_modal__VMKVt"};